import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import moneyFormat from '../functions/moneyFormat';
import RowEditIcon from './RowEditIcon';
import rateFormat from '../functions/rateFormat';
import displayDateTime from '../functions/displayDateTime';
import eyeIcon from '../../svgs/eye-details-icon.svg'; 
import { TableCell } from '@mui/material';

const StandardRow2 = ({ row, count, tableHeader, onEditClick=()=>{return}, enableEdit=false, rateTypeId=0, onMagnifyClick=()=>{return},stickyEnabled }) => {
    // show red icon for disabled (0) status or green icon for Active (1) status 
    const statusIcon = (status) =>{
        if ( status == true){
            return <img src={greenCircleIcon} class='data-table-icon-left'/>
        }
        else {
            return <img src={redCircleIcon} class='data-table-icon-left'/>
        }
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    console.log(tableHeader)
    // render component
    return(
        <>
            {/* order columns according to tableHeader object */}
            { tableHeader.map(el =>
                // apply statusIcon function to status column 
                el['format'] == 'active' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>{statusIcon(row[el['columnname']])}</TableCell>
                // show edit icon for last row 
                : el['format'] == 'blank' ?
                    <TableCell className={getRowClassName(el['columnorder'])}><RowEditIcon enable={enableEdit} onClick={()=>onEditClick(row)}/></TableCell> 
                : el['format'] == 'money' ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                : el['format'] == 'rate' ?
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{rateFormat(row[el['columnname']], rateTypeId)}</TableCell>
                : el['format'] == 'date' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']], true, false)}</TableCell>
                : el['format'] == 'date_ovr_offset' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']], true, true)}</TableCell>
                : el['format'] == 'magnify_icon' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}><RowEditIcon enable={true} onClick={()=>onMagnifyClick(row)} icon={eyeIcon} tooltip={'view'}/></TableCell>
                // standard display for other columns 
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
        </>
    ); 
}

export default StandardRow2; 